<template>
    <a
        :class="mobileView ? 'navbar-toggler cursor-pointer' : 'navbar-brand1 cursor-pointer'"
        type="button"
        :data-bs-toggle="mobileView ? 'offcanvas' : 'left-sidebar'"
        :data-bs-target="mobileView ? '.left-sidebar' : '.left-sidebar'"
        :aria-controls="mobileView ? 'left-sidebar' : 'left-sidebar'"
        aria-expanded="false"
        @click="setMini($event)"
    >
        <div class="ms-aside-toggler ms-toggler pl-0" data-target="#ms-side-nav" data-toggle="slideLeft">
            <span class="ms-toggler-bar" :class="!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'bg-dark' : `bg-light`"></span>
            <span class="ms-toggler-bar" :class="!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'bg-dark' : `bg-light`"></span>
            <span class="ms-toggler-bar" :class="!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'bg-dark' : `bg-light`"></span>
        </div>
    </a>
</template>

<script>
import { ref } from 'vue';

import { useStore } from '@/system_modules/store';
import { G } from '@/_common';

export default {
    name: "NavbarButtonC",
    props: {
        theme: {
            type: String,
            default: 'light'
        },
    },
    setup() {
        const store = useStore();

        const mobileView = ref(G.is_mobile());

        const setMini = (event) => {
            if( !mobileView.value ){
                store.setSidebarStatus(!store.getSidebarStatus(), event);
            }
        };

        return {
            G,
            mobileView,
            setMini,
        };
    },
}
</script>

<style lang="scss" scoped>
.ms-aside-toggler, .ms-nav-toggler {
    padding: .25rem .5rem;
    // padding-left: 0.75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: .25rem;
    cursor: pointer;
}
.ms-aside-toggler .ms-toggler-bar, .ms-nav-toggler .ms-toggler-bar {
    height: 2px;
    width: 20px;
    margin-bottom: 4px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    display: block;
}
.ms-aside-toggler:hover .ms-toggler-bar:nth-child(2), .ms-aside-toggler:hover .ms-toggler-bar:nth-child(3) {
    width: 20px;
}
.ms-aside-toggler .ms-toggler-bar:nth-child(3) {
    width: 10px;
}
.ms-aside-toggler .ms-toggler-bar:nth-child(2) {
    width: 15px;
}
</style>
